import currencyPairCheck from "utilities/currencyPairCheck";
import { formatMoney } from "utilities/formatMoney";
import { Country, State } from "country-state-city";


export const wareHouseCountry = ["Nigeria", "United States", "United Kingdom", "Ireland"];
export const wareHouseCountryList = () => Country?.getAllCountries().filter((country) =>
            wareHouseCountry.includes(country?.name)
)
export const selectedCountryStateOrProvince = (country) => {
    const selectedCountry = wareHouseCountryList()?.find((c) => c.name === country);
    if (selectedCountry) {
        return State.getStatesOfCountry(selectedCountry.isoCode).map((state) => ({
            value: state.name,
            displayValue: state.name,
        }));
    }
    return [];
}
export const loansList = [
    { text: "Active", value: "Active" },
    { text: "Draft", value: "Draft" },
];
export const paymentsList = [
    { text: "Processing", value: "pending" },
    { text: "Completed", value: "approved" },
    { text: "Rejected", value: "rejected" },
    { text: "Cancelled", value: "cancelled" },
];
export const financeTitles = {
    inventory_finance: "Inventory finance",
  payment_finance: "Payment finance",
    payable_finance: "Payables finance",
    receivable_finance: "Receivables finance",
};

export const Loans = "Loans";
export const Payments = "Payments";

export const FinancePayStatus = [
    { text: "All", value: "All" },
    { text: "Closed", value: "repaid" },
    { text: "Cancelled", value: "cancelled" },
    { text: "Rejected", value: "rejected" },
];

export const ExpectedStatus = {
    Draft: "draft",
    Pending: "pending",
    Disbursed: "disbursed",
};

export const displayCurrencyAndAmount = (currency, amount) => {
    if(isNaN(Number(amount))) return "--"
    return currencyPairCheck(currency) + " " + formatMoney(Math.round(amount));
};


export const radioFinanceOptions = [
    {
        value: "purchaseOrder",
        label: "Purchase order",
    },
    {
        value: "transaction",
      label: "Reverse factoring",
    },
    {
        value: "freightPayment",
        label: "Freight",
    },
];

export const managementFinanceOptions = [
  {
    value: "separate",
    label: "I’ll pay separately",
  },
  {
    value: "fromLoan",
    label: "Deduct from loan amount",
  },
];

export const fileTypeToUpload = {
    Transaction: "Transaction",
    Contract: "Contract",
    Freight: "Freight",
    Domiciliation: "Domiciliation",
  Other: "Other",
};

export const getOrderToDisplay = ({ isPayableFinance, businessId, data }) => {
    const isActiveBusiness =
        businessId === data?.business?._id &&
        data?.flexUserType === "supplier";
    const supplier = isPayableFinance ? data?.outbound : !isActiveBusiness
        ? data?.inbound
        : data?.outbound;
    return supplier
};
export const MINIMUM_AMOUNT = 2999999;
export const CRYPTO_MINIMUM_AMOUNT = 999;
export const MAXIMUM_AMOUNT = 200000000;

export const PaymentOptions = ["Invoice", "Purchase order", "Transaction", "Freight", "Other"];

export const formatInterestRate = (rate) => {
  if (rate === undefined || rate === null || rate === "") return "--";
  if (typeof rate === "string" && rate.endsWith("%")) return rate;
  const num = Number(rate);
  if (isNaN(num)) return "--";
  if (num === 0) return "0%";
  const rateStr = String(rate);
  if (rateStr.startsWith("0")) {
    return (num * 100) + "%";
  }
  return rateStr + "%";
};

export const getFinanceDataList = ({
  loadingSingleFinance,
  status,
  currency,
  requestedAmount,
  financeType,
  createdAt,
  isPaymentFinance,
  totalAmount,
  interestRate,
  interestAmount,
  tenure,
  paymentFinance,
  financeDetails,
  repaymentStructure,
  dataDetails,
  getPaidAmount,
  formatDate
}) => {
  return loadingSingleFinance
    ? []
    : status === "pending"
      ? [
        {
          label: "Amount requested",
          value: displayCurrencyAndAmount(currency, requestedAmount),
        },
        {
          label: "Loan type",
          value: financeTitles[financeType],
        },
        {
          label: status !== "draft" ? "Requested date" : "Created date",
          value: formatDate(createdAt),
        },
      ]
      : isPaymentFinance ? [
        {
          label: "Total due",
          value: displayCurrencyAndAmount(currency, totalAmount),
        }, 
        {
          label: "Interest rate",
          value: formatInterestRate(interestRate),
        },
        {
          label: "Interest amount",
          value: displayCurrencyAndAmount(currency, interestAmount),
        },
        {
          label: "Loan Amount",
          value: displayCurrencyAndAmount(currency, requestedAmount),
        },
        { label: "Tenure", value: tenure + " days" },
        { label: "Loan type", value: financeTitles[financeType] },
        { label: "Lateness fee", value: "--" },
        { label: "Transfer fee", value: displayCurrencyAndAmount(currency, paymentFinance?.transactionFee || 1) },
        ...(paymentFinance?.paymentDestination?.address && paymentFinance?.paymentDestination?.address !== "N/A"
          ? [
              {
                label: "Recipient address",
                value: paymentFinance?.paymentDestination?.address,
              },
            ]
          : []),
        ...(paymentFinance?.paymentDestination?.network && paymentFinance?.paymentDestination?.network !== "N/A"
          ? [
              {
                label: "Network",
                value: paymentFinance?.paymentDestination?.network,
              },
            ]
          : []),
        {
          label: "Requested date",
          value: formatDate(createdAt),
        },
        ...(status === "disbursed"
          ? [
            {
              label: "Disbursal date",
              value: formatDate(paymentFinance?.updatedAt),
            },
          ]
          : []),
      ] : [
        {
          label: "Amount paid",
          value: getPaidAmount(),
        },
        {
          label: "Total due",
          value: displayCurrencyAndAmount(currency, totalAmount),
        },
        {
          label: "Interest rate",
          value: formatInterestRate(interestRate),
        },
        {
          label: "Amount requested",
          value: displayCurrencyAndAmount(currency, requestedAmount),
        },
        { label: "Repayment terms", value: repaymentStructure ?? "--" },
          { label: "Tenure", value: tenure + " days" },
          { label: "Loan type", value: financeTitles[financeType] },
          { label: "Sub Category", value: radioFinanceOptions.find(item => item.value === dataDetails?.financeCategory)?.label || 'N/A' },
        { label: "Lateness fee", value: "--" },
          { label: "Management fee (1%)", value: managementFinanceOptions.find(item => item.value === financeDetails?.managementType)?.label },
        {
          label: status !== "draft" ? "Requested date" : "Created date",
          value: formatDate(createdAt),
        },
      ];
};
